/**
 * CORS monitor helpers — same-origin `/api` and connection-refused are not CORS policy failures.
 */

export function isSameOriginFetchUrl(url: string, pageOrigin: string): boolean {
  const trimmed = String(url || '').trim();
  if (!trimmed) return false;
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) return true;
  try {
    const parsed = new URL(trimmed, `${pageOrigin}/`);
    return parsed.origin === pageOrigin;
  } catch {
    return false;
  }
}

export function isNetworkFailureNotCors(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : String((error as { message?: unknown })?.message || error || '');
  const lowered = message.toLowerCase();
  if (lowered.includes('failed to fetch')) return true;
  if (lowered.includes('networkerror')) return true;
  if (lowered.includes('load failed')) return true;
  if (lowered.includes('err_connection_refused')) return true;
  if (lowered.includes('err_connection_reset')) return true;
  if (lowered.includes('network request failed')) return true;
  return false;
}
